<template>
  <Layout>
    <confirm-modal
      v-bind:bodyText="textConfirmDeleteModal"
      v-bind:show="confirmDeleteModal"
      @confirm="onDelete()"
      @hidden="
        confirmDeleteModal = false;
        textConfirmDeleteModal = '';
        id = 0;
      "
    >
    </confirm-modal>
    <PageHeader :title="title" :items="itemsPageHeader" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-8"></div>
              <div class="col-sm-4">
                <div class="text-sm-right">
                  <button
                    @click="
                      $router.push({
                        name: 'application_detail',
                        params: { id: 'new' },
                      })
                    "
                    type="button"
                    class="btn btn-success waves-effect waves-light"
                  >
                    <i class="fa fa-plus"></i>
                    Add New Application
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-row form-group">
                  <label class="col-md-4 col-form-label">Code</label>
                  <div class="col-md-8">
                    <input
                      v-model="filter.code"
                      type="text"
                      placeholder="Code"
                      class="form-control"
                    />
                    <!-- onkeypress="return event.charCode >= 48 && event.charCode <= 57" -->
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-row form-group">
                  <label class="col-md-4 col-form-label">Name</label>
                  <div class="col-md-8">
                    <input
                      v-model="filter.name"
                      type="text"
                      placeholder="Name"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-row form-group">
                  <label class="col-md-4 col-form-label">Status</label>
                  <div class="col-form-label row" style="margin-left: 0px">
                    <b-form-checkbox
                      @change="onSelectAll($event)"
                      class="custom-checkbox custom-checkbox-outline custom-checkbox-info mb-3"
                      style="margin-right: 10px"
                      name="all"
                      id="all"
                      v-model="isSelectAllStatus"
                      >All</b-form-checkbox
                    >
                    <b-form-checkbox
                      v-model="filter.status"
                      value="Active"
                      class="custom-checkbox custom-checkbox-outline custom-checkbox-success mb-3"
                      style="margin-right: 10px"
                      name="active"
                      id="active"
                      >Active</b-form-checkbox
                    >
                    <b-form-checkbox
                      v-model="filter.status"
                      value="Inactive"
                      class="custom-checkbox custom-checkbox-outline custom-checkbox-danger mb-3"
                      style="margin-right: 10px"
                      name="inactive"
                      id="inactive"
                      >Inactive</b-form-checkbox
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 text-sm-right">
                <div class="button-items">
                  <button
                    type="button"
                    class="btn btn-primary waves-effect"
                    @click="onFilter()"
                  >
                    <i class="bx bx-search font-size-16 align-middle mr-2"></i>
                    Search
                  </button>
                  <button
                    type="button"
                    class="btn btn-light waves-effect"
                    @click="onClear()"
                  >
                    <i class="bx bx-reset font-size-16 align-middle mr-2"></i>
                    Claer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card" v-if="showDataTable">
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Size&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                      @change="onFilter()"
                    ></b-form-select
                    >&nbsp;Records
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    <b-form-input
                      v-model="search"
                      type="search"
                      :placeholder="`Search in page ${pageNo} `"
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive">
                  <b-table
                    class="table table-centered table-nowrap"
                    ref="applicationtable"
                    :empty-text="'Not found any result'"
                    :show-empty="items.length == 0"
                    :bordered="true"
                    :filter="search"
                    :filter-included-fields="['code', 'display_name']"
                    :items="items"
                    align="center"
                    v-bind:fields="fields"
                    @filtered="onFiltered"
                    :perPage="perPage"
                  >
                    <template v-slot:cell(index)="data">
                      <div class="text-right">
                        {{ firstRowOnPage + data.index }}
                      </div>
                    </template>
                    <template v-slot:cell(channel_allows)="data">
                      <div>
                        <h6
                          v-for="(ch, index) in data.item.channel_allows"
                          :key="index"
                        >
                          <b-badge variant="info">{{ ch.type }}</b-badge>
                        </h6>
                      </div>
                    </template>
                    <template v-slot:cell(status)="data">
                      <span
                        class="label"
                        :class="'label-' + data.value.toLowerCase()"
                        v-html="data.value"
                      ></span>
                    </template>
                    <template v-slot:cell(action)="data">
                      <div class="button-items">
                        <button
                          @click="
                            $router.push({
                              name: 'application_detail',
                              params: { id: data.item.id },
                            })
                          "
                          type="button"
                          class="btn btn-warning waves-effect waves-light"
                          title="Edit"
                        >
                          <i class="mdi mdi-pencil label-icon"></i>
                        </button>
                        <button
                          @click="
                            onConfirmDelete(
                              data.item.id,
                              data.item.display_name
                            )
                          "
                          type="button"
                          class="btn btn-danger waves-effect waves-light"
                          title="Delete"
                        >
                          <i class="mdi mdi-trash-can label-icon"></i>
                        </button>
                      </div>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
            <div class="row" v-if="isItems">
              <div class="col-lg-4">
                <div style="position: relative; top: 7px">
                  Result {{ firstRowOnPage }} - {{ lastRowOnPage }} From
                  {{ totalRecords }} Records
                </div>
              </div>
              <div class="col-lg-8">
                <b-pagination
                  :total-rows="totalRecords"
                  :per-page="perPage"
                  v-model="pageNo"
                  @change="onClickPagination($event)"
                  class="pagination pagination-rounded justify-content-end mb-2"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- <Loading :isLoading="isLoading"/> -->
        <loading :active.sync="isLoading" ></loading>

      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { FormatDate, FormatDateTime } from "@/helpers/utils/format-date.js";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Vue from "vue";
import Swal from "sweetalert2";
import appConfig from "@/app.config";
import { eventBus } from "@/main.js";
import ConfirmModalComponnent from "@/components/share/modal-confirm.vue";
import { applicationComputed, applicationMethods } from "@/state/helpers";
import applicationService from "@/helpers/service/application-provider";
import { StatusEnum, OwnApplicationStatus } from "@/enum/application.enum.js";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
export default {
  name: "application",
  page: {
    title: "Application",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader,Loading, "confirm-modal": ConfirmModalComponnent },
  data() {
    return {
      isLoading: false,

      search: null,
      title: "Application",
      itemsPageHeader: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Application",
          active: true,
        },
      ],
      fields: [
        {
          key: "index",
          label: "index",
          thStyle: "width:80px",
          sortable: false,
        },
        {
          key: "code",
          label: "Application Code",
          sortable: true,
        },
        {
          key: "display_name",
          label: "Application Name",
          sortable: true,
        },
        {
          key: "channel_allows",
          label: "Channel",
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          thStyle: "width:120px",
          sortable: true,
          tdClass: "text-center",
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:80px",
        },
      ],
      listModel: {
        type: Object,
        default: () => {
          return {
            firstRowOnPage: 0,
            items: [],
            lastRowOnPage: 0,
            pageNo: 0,
            totalPages: 0,
            totalRecords: 0,
            pageSize: 0,
            prevPage: 0,
            nextPage: 0,
          };
        },
      },
      items: [],
      pageNo: 0,
      totalPages: 0,
      firstRowOnPage: 0,
      lastRowOnPage: 0,
      totalRecords: 0,
      perPage: 50,
      filter: {
        code: "",
        name: "",
        status: [],
        isOwnApplication: [],
      },
      isSelectAllStatus: true,
      selectAllStatus: ["Active", "Inactive"],
      pageOptions: [5, 10, 25, 50, 100],
      confirmDeleteModal: false,
      textConfirmDeleteModal: "",
      id: 0,
      showDataTable: false,
    };
  },
  computed: {
    ...applicationComputed,
    isItems() {
      return this.$validate.anyArrayObjectValid(this.items);
    },
  },
  mounted() {
    // this.filter = Object.assign({}, this.GET_FILTER_APPLICATION);
    // if (this.filter.isFilter) {
    //   this.onFilter();
    // }
  },
  watch: {
    "filter.status": {
      handler() {
        var filterStatusLength = this.$validate.anyArrayObjectValid(
          this.filter.status
        )
          ? this.filter.status.length
          : 0;
        var selectAllStatusLength = this.$validate.anyArrayObjectValid(
          this.selectAllStatus
        )
          ? this.selectAllStatus.length
          : 0;
        this.isSelectAllStatus = filterStatusLength === selectAllStatusLength;
      },
      deep: true,
    },
    isSelectAllStatus:{
      handler(newVal) {
        if(newVal){
          this.filter.status = ["Active", "Inactive"]
        }
      },
      immediate:true
    },
    // GET_FILTER_APPLICATION(val, oldVal) {
    //   this.filter = Object.assign({}, val);
    // },
    listModel: function (value) {
      this.totalPages = value.totalPages;
      this.firstRowOnPage = (value.pageNo - 1) * value.pageSize + 1;
      this.lastRowOnPage =
        value.pageSize <= 0
          ? value.totalRecords
          : Math.min(value.pageNo * value.pageSize, value.totalRecords);
      this.totalRecords = value.totalRecords;
      // this.$refs.applicationtable.localSortBy = "";
      this.items = value.items;
      this.perPage = value.pageSize;
      this.pageNo = value.pageNo;
    },
  },
  methods: {
    ...applicationMethods,
    onSelectAll(event) {
      this.filter.status = event ? this.selectAllStatus : [];
    },
    onSelectAllOwnApplication(event) {
      // this.filter.isOwnApplication = event ? this.selectAllOwnApplication : [];
    },
    async onFiltered(filteredItems) {
      this.totalPages = filteredItems.length;
    },
    async onClickPagination(pageNo) {
      await this.getApplicationAsync(pageNo);
    },
    async onFilter() {
      
      this.isLoading = true;
      this.showDataTable = false;

      await this.getApplicationAsync("");
      this.ADD_FILTER_APPLICATION(this.filter);
    },
    async getApplicationAsync(pageNo) {
      this.search = "";
      let params = new URLSearchParams();
      params.append("pageSize", this.perPage);
      if (this.$validate.isValid(pageNo)) params.append("page", pageNo);
      params.append("code", this.filter.code.trim() || "");
      params.append("name", this.filter.name.trim() || "");
      this.filter.status.forEach((element) => {
        params.append("status", element);
      });

      let result = await applicationService.getApplicationsAsync(params);
      if (result.status === 200) {
        this.isLoading = false;

        this.listModel = result.data;
        this.showDataTable = true;

      } else if (result.response.status === 404) {
        console.log("error", result.response.data.message);
      } else {
        eventBus.$emit("error-modal", result.response.data.message);
      }
    },
    onClear() {
      this.filter.code = "";
      this.filter.name = "";
      this.filter.status = [];
      // this.filter.isOwnApplication = [];
    },
    onConfirmDelete(id, name) {
      this.id = id;
      this.textConfirmDeleteModal =
        "คุณต้องการลบ Application <b>" + name + "</b> หรือไม่ ?";
      this.confirmDeleteModal = true;
    },
    async onDelete() {
      let result = await applicationService.deleteApplicationMasterByIdAsync(
        this.id
      );
      if (result.status === 200) {
        this.textConfirmDeleteModal = "";
        this.confirmDeleteModal = false;
        this.id = 0;
        this.$utils.notification("success", "ลบข้อมูลสำเร็จ", 1500);
        this.onFilter();
      } else {
        this.textConfirmDeleteModal = "";
        this.confirmDeleteModal = false;
        this.id = 0;
        eventBus.$emit("error-modal", result.response.data.message);
      }
    },
  },
};
</script>
<style></style>